import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ChatMessage } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class ChatMessageEventService implements OnDestroy {
  chatMessageSentEvent: Subject<ChatMessage> = new Subject<ChatMessage>();
  chatMessageReadEvent: Subject<ChatMessage> = new Subject<ChatMessage>();
  constructor() {}

  ngOnDestroy() {
    this.chatMessageSentEvent.complete();
    this.chatMessageReadEvent.complete();
  }

  getChatMessageSentEvent(): Observable<ChatMessage> {
    return this.chatMessageSentEvent.asObservable();
  }

  getChatMessageReadEvent(): Observable<ChatMessage> {
    return this.chatMessageReadEvent.asObservable();
  }

  sendChatMessageSentEvent(chatMessage: ChatMessage) {
    this.chatMessageSentEvent.next(chatMessage);
  }

  sendChatMessageReadEvent(chatMessage: ChatMessage) {
    this.chatMessageReadEvent.next(chatMessage);
  }
}
